import { faUserShield } from "@fortawesome/free-solid-svg-icons";
import React from "react";
import LegalPageLayout from "../Components/LegalPageLayout";

function PrivacyME() {
  return (
    <LegalPageLayout
      titleId="privacy-me-title"
      icon={faUserShield}
      title="Privacy Policy (Expensio)"
      description={
        <p>Your privacy is our priority. We protect your data with care.</p>
      }
    >
      <p className="effective-date">Effective Date: June 18, 2026</p>
      <p>
        Expensio is a mobile application developed and operated by MileSoft.
        MileSoft is the data controller for personal information processed
        through Expensio. For privacy requests, data protection officer (DPO)
        requests, and controller contact purposes, email us at{" "}
        <a href="mailto:privacy@milesoft.africa">privacy@milesoft.africa</a>.
      </p>

      <h5>Information We Collect</h5>
      <p>Expensio may collect or process the following information:</p>
      <ul>
        <li>Name, email address, Google sign-in information, and user ID</li>
        <li>
          Expense records you create, including title, amount, category, date,
          and optional notes
        </li>
        <li>Account settings and app preferences</li>
        <li>
          Device ID, device type, operating system version, app version, crash
          logs, diagnostics, app activity, and anonymous usage analytics if
          enabled
        </li>
      </ul>

      <h5>How We Use Information and Legal Basis</h5>
      <p>
        We use information to create and manage your account, authenticate
        sign-in, store and synchronize expense records, provide charts and
        summaries, improve reliability, respond to support requests, protect
        against misuse, and comply with legal obligations. Our legal basis for
        processing may include performance of a contract or requested service,
        consent, legitimate interests in operating and securing the app, legal
        obligations, and processing requested by you.
      </p>

      <h5>Data Storage and Security</h5>
      <p>
        Expensio may use trusted cloud services, including Firebase
        Authentication and Cloud Firestore provided by Google. We use reasonable
        technical and organizational safeguards, including HTTPS and encryption
        in transit where data is sent to our services or service providers,
        authentication controls, and cloud security protections. No system can
        guarantee absolute security.
      </p>

      <h5>Data Sharing, Sales, and Targeted Advertising</h5>
      <p>
        MileSoft does not sell personal information. We do not share personal
        information with unrelated third parties for their own marketing. We may
        share limited information with service providers needed to operate
        Expensio, including Firebase Authentication, Firestore, Google Sign-In,
        analytics if enabled, when required by law, to protect users and
        systems, or during a business transfer.
      </p>
      <p>
        You may opt out of any sale, sharing, or targeted advertising use of
        personal information by emailing{" "}
        <a href="mailto:privacy@milesoft.africa">privacy@milesoft.africa</a>. We
        will honor applicable opt-out rights even though we do not sell personal
        information.
      </p>

      <h5>Data Retention</h5>
      <p>
        We retain your data while your account remains active or as necessary to
        provide Expensio. If your account is deleted, related personal data will
        be deleted or anonymized unless limited retention is required or
        permitted for legal compliance, security, fraud prevention, dispute
        resolution, backups, or business records.
      </p>

      <h5>Your Privacy Rights</h5>
      <p>
        Depending on where you live, including under the GDPR, CCPA/CPRA, VCDPA,
        LGPD, and other applicable privacy laws, you may have the right to
        request access to personal information we collect, request correction or
        rectification of inaccurate information, request deletion, request a
        portable copy, object to or restrict certain processing, withdraw
        consent where processing is based on consent, and know whether personal
        information is sold or shared.
      </p>
      <p>
        California residents may exercise CCPA/CPRA rights to know, access,
        correct, delete, and opt out of sale or sharing. Virginia residents may
        exercise VCDPA rights to access, correct, delete, obtain a copy, and opt
        out of targeted advertising, sale, or certain profiling. Users in Brazil
        may exercise LGPD rights, including confirmation, access, correction,
        anonymization, deletion, portability, information about sharing, and
        consent withdrawal. Users in the EEA or UK may exercise GDPR rights,
        including access, rectification, erasure, restriction, objection,
        portability, and the right to lodge a complaint with a supervisory
        authority.
      </p>
      <p>
        To make a privacy rights request, contact{" "}
        <a href="mailto:privacy@milesoft.africa">privacy@milesoft.africa</a>.
      </p>

      <h5>Account and Data Deletion</h5>
      <p>
        You may edit or delete expense records in the app where available. You
        may also request deletion of your account and associated data by
        contacting us with the email address linked to your Expensio account.
      </p>

      <h5>Children's Privacy</h5>
      <p>
        Expensio is not intended for children under 13. We do not knowingly
        collect personal information from children.
      </p>

      <h5>Changes to This Privacy Policy</h5>
      <p>
        MileSoft may update this Privacy Policy from time to time. When we
        update it, we will revise the effective date and may notify users
        through the app, email, or another reasonable method.
      </p>

      <h5>Contact Us</h5>
      <p>
        <strong>Company and App Provider:</strong> MileSoft
        <br />
        <strong>App:</strong> Expensio
        <br />
        <strong>Controller and DPO Contact:</strong>{" "}
        <a href="mailto:privacy@milesoft.africa">privacy@milesoft.africa</a>
        <br />
        <strong>Location:</strong> Malawi
      </p>
    </LegalPageLayout>
  );
}

export default PrivacyME;
